import Image from "next/image";

interface SizeRecommendationProps {
  text: string;
  backgroundColor: string;
  textColor?: string;
  icon?: string;
  iconBackgroundColor?: string;
}

const SizeRecommendation = ({ 
  text, 
  backgroundColor,
  textColor = "#854d0e",
  icon,
  iconBackgroundColor = "#eab308"
}: SizeRecommendationProps) => {
  return (
    <div 
      className="border rounded-lg p-4 flex items-center gap-3"
      style={{ 
        backgroundColor,
        borderColor: backgroundColor === '#fefce8' ? '#fef3c7' : backgroundColor 
      }}
    >
      <div 
        className="w-8 h-8 rounded-full flex items-center justify-center shrink-0"
        style={{ 
          backgroundColor: iconBackgroundColor
        }}
      >
        {icon ? (
          <Image 
            src={icon} 
            alt="Info" 
            width={16} 
            height={16}
            className="invert"
          />
        ) : (
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            className="text-white"
          >
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="16" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12.01" y2="8"/>
          </svg>
        )}
      </div>
      <p 
        className="text-sm font-medium"
        style={{ 
          color: textColor
        }}
      >
        {text}
      </p>
    </div>
  );
};

export default SizeRecommendation;